import { Box, Button, Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useConfigQuery } from "../../../../../api/payout";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { hallSelector } from "../../../../../redux/hallReducer";
import { PaymentListItem, PaymentListItemHallFormItem } from "../../interface";
import OptionsCell from "./options-cell";
import { typeToText } from "../../../functions";

interface PaymentsConfigProps {
    hall_id: number;
    paymentListItems: PaymentListItemHallFormItem[];
    setPaymentListItems: (paymentListItems: PaymentListItemHallFormItem[]) => void;
};

const PaymentsConfig = ({ paymentListItems, setPaymentListItems }: PaymentsConfigProps) => {
    const { data: config } = useConfigQuery();
    const { data: hall } = useSelector(hallSelector);
    const methods = useMemo(() => {
        if (!!!config || !config.success || !hall) {
            return [];
        }
        return config.data.filter(item => item.paymentListItemCurrencies.find(cur => cur.currency_id === hall.currency_id));
    }, [config, hall]);
    const methodsMap = useMemo(() => {
        const map: { [key: number]: PaymentListItem } = {};
        methods.forEach(method => map[method.id] = method);
        return map;
    }, [methods]);
    const [selectedMethod, setSelectedMethod] = useState(0);
    const options = useMemo(() => methods.filter(method => !paymentListItems.find(item => item.payment_list_item_id === method.id)).map(item => <option key={item.id} value={item.id}>{item.is_withdraw ? "Вывод" : "Пополнение"}: {item.title} ({item.method}, {typeToText(item.type)})</option>), [methods, paymentListItems]);
    const paymentListItemsSorted = useMemo(() => {
        return paymentListItems.slice().sort((a, b) => a.payment_list_item_id - b.payment_list_item_id);
    }, [paymentListItems]);
    return <Box style={{ marginTop: "1em" }} width="100%">
        {options.length > 0 && <Grid style={{ display: "flex", justifyContent: "space-around" }} item xs={12} sm={12}>
            <select value={selectedMethod} onChange={e => setSelectedMethod(+e.target.value)}>
                <option value={0}>Выберите метод</option>
                {options}
            </select>
            <Button disabled={selectedMethod === 0} variant="contained" onClick={() => {
                setPaymentListItems([...paymentListItems, { payment_list_item_id: selectedMethod, batch: null, min: null, max: null, mod: null, title: null, caption: null, bonus: null, cancel_timer: null }]);
                setSelectedMethod(0);
            }}>Добавить</Button>
        </Grid>
        }
        <Grid item xs={12} sm={12}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Направление</TableCell>
                        <TableCell>Провайдер</TableCell>
                        <TableCell>Тип</TableCell>
                        <TableCell>Заголовок</TableCell>
                        <TableCell>Настройки</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paymentListItemsSorted.map(paymentListItem => {
                        const method = methodsMap[paymentListItem.payment_list_item_id];
                        if (!method) {
                            return null;
                        }
                        return <TableRow key={method.id}>
                            <TableCell>{method.id}</TableCell>
                            <TableCell>{method.is_withdraw ? "Вывод" : "Пополнение"}</TableCell>
                            <TableCell>{method.method}</TableCell>
                            <TableCell>{typeToText(method.type)}</TableCell>
                            <TableCell>{method.title}</TableCell>
                            <TableCell>
                                <OptionsCell
                                    config={method}
                                    batch={paymentListItem.batch}
                                    setBatch={batch => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], batch };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    min={paymentListItem.min}
                                    setMin={min => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], min };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    max={paymentListItem.max}
                                    setMax={max => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], max };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    mod={paymentListItem.mod}
                                    setMod={mod => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], mod };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    title={paymentListItem.title}
                                    setTitle={title => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], title };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    caption={paymentListItem.caption}
                                    setCaption={caption => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], caption };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    bonus={paymentListItem.bonus}
                                    setBonus={bonus => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], bonus };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                    cancel_timer={paymentListItem.cancel_timer}
                                    setCancelTimer={cancel_timer => {
                                        const idx = paymentListItems.findIndex(item => item.payment_list_item_id === method.id);
                                        const newPaymentListItems = [...paymentListItems];
                                        newPaymentListItems[idx] = { ...newPaymentListItems[idx], cancel_timer };
                                        setPaymentListItems(newPaymentListItems);
                                    }}
                                />
                            </TableCell>
                            <TableCell>
                                <Button size="small" variant="contained" onClick={() => setPaymentListItems(paymentListItems.filter(item => item.payment_list_item_id !== method.id))}>Удалить</Button>
                            </TableCell>
                        </TableRow>;
                    })}
                </TableBody>
            </Table>
        </Grid>
    </Box >
}

export default PaymentsConfig;